var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products.length
    ? _c(
        "section",
        { staticClass: "related-products" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "slick",
            { attrs: { options: _vm.slickOptions } },
            _vm._l(_vm.products, function(product) {
              return _c("listing-product-item", {
                key: product.id,
                attrs: { product: product, translations: _vm.translations }
              })
            }),
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }